module.exports = __webpack_public_path__ + "img/Intelligent Vision.a88ca389.svg";